import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
export var ILeadModalService = /*#__PURE__*/ function() {
    "use strict";
    function ILeadModalService() {
        _class_call_check(this, ILeadModalService);
    }
    var _proto = ILeadModalService.prototype;
    /**
   * Handle Lead Modal
   */ _proto.handleLeadModal = function handleLeadModal(leadDetail) {
        this.customLeadModalEvent = new CustomEvent("leadModalNotificationEvent", {
            detail: leadDetail
        });
        document.dispatchEvent(this.customLeadModalEvent);
    };
    return ILeadModalService;
}();
